import { useState } from "react";
import "./navbar.css";
import logo from '../../../../assets/logo.png';

const navigation = [
];

export default function Navbar() {
    const [mobileOpen, setMobileOpen] = useState(false);

    return (
        <header className="navbar">
            <nav className="navbar-container">

                <div>
                    <img
                        src={logo}
                        alt="Logo Icon"
                        className="logo-image"
                        style={{ width: "25px", height: "25px", marginTop: "5px" }}
                    />
                    <a href="/" className="logo">Inveyst</a>
                </div>
                <div className="nav-links">
                    {navigation.map((item) => (
                        <a key={item.name} href={item.href} className="nav-link">
                            {item.name}
                        </a>
                    ))}
                </div>



                <button className="menu-btn" onClick={() => setMobileOpen(!mobileOpen)}>
                    {mobileOpen ? "✖" : "☰"}
                </button>

                {mobileOpen && (
                    <div className="mobile-menu">
                        {navigation.map((item) => (
                            <a
                                key={item.name}
                                href={item.href}
                                className="mobile-link"
                                onClick={() => setMobileOpen(false)}
                            >
                                {item.name}
                            </a>
                        ))}
                        <button className="login-btn">Login</button>
                        <button className="signup-btn">Sign Up</button>
                    </div>
                )}
            </nav>
        </header>
    );
}
